<mat-form-field class="mrn-form-field" [appearance]="appearance">
  <mat-label>MRN</mat-label>
  <input matInput placeholder="Medical Record Number" [formControl]="control" />

  <mat-hint *ngIf="control?.pending">Validating MRN…</mat-hint>

  <mat-hint *ngIf="control?.valid && control?.dirty && !control?.pending"> MRN is available </mat-hint>

  <mat-error *ngIf="control?.dirty && control?.hasError('mrnTaken')">
    MRN is already assigned to
    <a class="assigned-to-user-link" [href]="chartLink(error?.userId)" target="_blank" rel="noopener noreferrer">
      {{ error?.firstName }} {{ error?.lastName }}
    </a>
  </mat-error>

  <mat-error *ngIf="control?.dirty && control?.hasError('mrnServerError')">
    Unable to validate MRN at this time. Please try again.
  </mat-error>
</mat-form-field>
